import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'No, close',
    cancelTransferSucceed: 'The transfer was successfully canceled',
    confirm: 'Yes, cancel the transfer',
    description: 'This action is non-reversible.',
    title: 'Are you sure you want to cancel this transfer?',
  },
  fr: {
    cancel: 'Non, fermer',
    cancelTransferSucceed: 'Le virement a été annulé avec succès',
    confirm: 'Oui, annuler le virement',
    description: 'Cette action est irréversible.',
    title: 'Êtes-vous sûr·e de vouloir annuler ce virement ?',
  },
});

export default locales;
